import React from "react";
import {
   ArrowRightOutlined,
   CalendarOutlined,
   HeartOutlined,
   SearchOutlined
} from "@ant-design/icons";
import { content } from "./content";

const CARD_ICONS = {
   signs: SearchOutlined,
   "self-exam": HeartOutlined,
   "check-up": CalendarOutlined
};

const EducationCard = ({ card }) => {
   const Icon = CARD_ICONS[card.key];
   const body = (
      <>
         <span className="tr-done__card-icon" aria-hidden="true">
            {Icon && <Icon />}
         </span>
         <h3>{card.title}</h3>
         <p>{card.text}</p>
      </>
   );

   return card.href ? (
      <a className="tr-done__card" href={card.href} target="_blank" rel="noopener noreferrer">
         {body}
      </a>
   ) : (
      <div className="tr-done__card">{body}</div>
   );
};

/**
 * Replaces SurveyConfirmation for this survey and takes the same props, so every place Preview
 * shows a confirmation shows this page instead.
 */
const TetoriRozeCompletion = ({ isSurveySubmitted = false, surveySubmittedSuccessfully = "" }) => {
   const { completion } = content;
   const isKiosk = surveySubmittedSuccessfully === "multi-use-kiosk";

   const subtitle = isSurveySubmitted
      ? completion.alreadySubmitted
      : isKiosk
      ? completion.kioskReset
      : completion.subtitle;

   return (
      <div className="tr-completion">
         <div className="tr-card tr-done">
            <span className="tr-done__icon" aria-hidden="true">
               <HeartOutlined />
            </span>
            <h2 className="tr-done__title">{completion.title}</h2>
            <p className="tr-done__subtitle">{subtitle}</p>

            {!isKiosk && (
               <>
                  <p className="tr-done__text">
                     {completion.textHref ? (
                        <a href={completion.textHref} target="_blank" rel="noopener noreferrer">
                           {completion.text}
                        </a>
                     ) : (
                        completion.text
                     )}
                  </p>

                  <div className="tr-done__cards">
                     {completion.cards.map((card) => (
                        <EducationCard key={card.key} card={card} />
                     ))}
                  </div>

                  {/* Hidden until the campaign page's link is filled in content.js. */}
                  {completion.cta.href && (
                     <div className="tr-done__actions">
                        <a
                           className="tr-btn tr-btn--primary"
                           href={completion.cta.href}
                           target="_blank"
                           rel="noopener noreferrer"
                        >
                           <span>{completion.cta.label}</span>
                           <ArrowRightOutlined />
                        </a>
                     </div>
                  )}
               </>
            )}
         </div>
      </div>
   );
};

export default TetoriRozeCompletion;
